module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc7",
      "id": "dd7"
    }
  }, [_c('i', [_vm._v("January 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "amJanuary5"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0010-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("We who have believed do enter that rest")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0010-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("hey weary themselves to commit iniquity. • I see another law in my members, warring against the law of my mind, and bringing me into captivity to the law of sin which is in my members. O wretched man that I am! Who will deliver me from this body of death?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-05-6"
    }
  }, [_vm._v("Come to Me, all you who labor and are heavy laden, and I will give you rest. • Having been justified by faith, we have peace with God through our Lord Jesus Christ, through whom also we have access by faith into this grace in which we stand, and rejoice in hope of the glory of God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-05-7"
    }
  }, [_vm._v("He who has entered His rest has himself also ceased from his works. • Not having my own righteousness, which is from the law, but that which is through faith in Christ, the righteousness which is from God by faith. • “This is the rest with which you may cause the weary to rest,” and, “this is the refreshing.”")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 4:3; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(". 9:5; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 7:23–24; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATT")]), _vm._v(". 11:28; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 5:1–2; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 4:10; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(". 3:9; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 28:12")]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "aeJanuary5"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0010-08-11"
    }
  }, [_c('span', [_c('i', [_vm._v("Set a guard, O L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", over my mouth; keep watch over the door of my lips")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0010-09-13"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("f You, L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", should mark iniquities, O Lord, who could stand? • They rebelled against His Spirit, so that he spoke rashly with his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-10-16"
    }
  }, [_vm._v("Not what goes into the mouth defiles a man; but what comes out of the mouth, this defiles a man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-10-17"
    }
  }, [_vm._v("A whisperer separates the best of friends. • There is one who speaks like the piercings of a sword, but the tongue of the wise promotes health. The truthful lip shall be established forever, but a lying tongue is but for a moment. • No man can tame the tongue. It is an unruly evil, full of deadly poison. • Out of the same mouth proceed blessing and cursing. My brethren, these things ought not to be so.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-10-19"
    }
  }, [_vm._v("Put off all these: anger, wrath, malice, blasphemy, filthy language. . . . Do not lie to one another, since you have put off the old man with his deeds. • For this is the will of God, your sanctification. • In their mouth was found no deceit.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 141:3; 130:3; 106:33; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATT")]), _vm._v(". 15:11; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 16:28; 12:18; 12:19; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" 3:8; 3:10; C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OL")]), _vm._v(". 3:8–9; 1 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESS")]), _vm._v(". 4:3; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EV")]), _vm._v(". 14:5")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-372d71df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter7.vue
// module id = 84
// module chunks = 0